export function getView(actionType) {
  switch (actionType) {
    case 'letter':
      return 'GenerateLetter'
    case 'review':
      return 'Review'
    default:
      return 'No'
  }
}
